import { render, staticRenderFns } from "./giftToMembers.vue?vue&type=template&id=7910dda2&scoped=true"
import script from "./giftToMembers.vue?vue&type=script&lang=js"
export * from "./giftToMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910dda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7910dda2')) {
      api.createRecord('7910dda2', component.options)
    } else {
      api.reload('7910dda2', component.options)
    }
    module.hot.accept("./giftToMembers.vue?vue&type=template&id=7910dda2&scoped=true", function () {
      api.rerender('7910dda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/giftToMembers.vue"
export default component.exports